import useAuth from '@app/auth/use-auth';
import { NavCountBadge } from '@app/components/layout/sidebar/components/nav-count-badge';
import { useItemScope } from '@app/purchased-goods/components/item-detail/use-item-scope';
import { useGetPurchasedFoodAndDrinkList } from '@shared/api/hooks/purchased-goods/food-and-drink';
import { Tab } from '@shared/components/page-tabs';
import { Badge } from '@shared/components/ui/badge';
import { generatePath } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../purchased-goods-routes';
import { usePurchasedFoodAndDrinkItem } from './purchased-food-and-drink-item-context';

export function usePurchasedFoodAndDrinkTabs(): Tab[] {
  const { data } = useGetPurchasedFoodAndDrinkList();
  const reviewCount = data?.numberOfItemsToReview as number;
  return [
    {
      title: 'Items',
      href: purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK,
    },
    {
      title: 'Data coverage',
      href: purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_DATA_COVERAGE,
    },
    {
      title: 'Review',
      href: generatePath(purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_REVIEW),
      icon: reviewCount > 0 ? <NavCountBadge count={reviewCount} /> : undefined,
    },
  ];
}

export function usePurchasedFoodAndDrinkItemsTabs(): Tab[] {
  const { item } = usePurchasedFoodAndDrinkItem();
  const { user } = useAuth();
  const { scopeSearch } = useItemScope();

  const params = { item_uuid: item?.uuid || ':item_uuid' };

  const tabs: Tab[] = [
    {
      title: 'Overview',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_ITEM,
          params
        ) + scopeSearch,
    },
    {
      title: 'Modelling',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_ITEM_MODELLING,
          params
        ) + scopeSearch,
    },
    {
      title: 'Purchases',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_ITEM_PURCHASES,
          params
        ) + scopeSearch,
    },
  ];

  if (user?.features.cost) {
    tabs.push({
      title: 'Spend',
      href:
        generatePath(
          purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_ITEM_SPEND,
          params
        ) + scopeSearch,
      icon: (
        <Badge variant="new_feature" size="sm">
          new
        </Badge>
      ),
    });
  }

  return tabs;
}
